import React from 'react';

import { SVGComponentProps } from './svg.types';

const HashSVG = ({
  size = '1em',
  wrapperClass,
  fill = 'currentColor',
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherProps}
      >
        <path
          d="M5.18887 9.33333L5.46915 6.66667H2.66602V5.33333H5.60929L5.95964 2H7.30028L6.94995 5.33333H9.60928L9.95962 2H11.3003L10.9499 5.33333H13.3327V6.66667H10.8098L10.5295 9.33333H13.3327V10.6667H10.3894L10.0391 14H8.69842L9.04875 10.6667H6.38941L6.03906 14H4.69838L5.04873 10.6667H2.66602V9.33333H5.18887ZM6.52955 9.33333H9.18888L9.46915 6.66667H6.80982L6.52955 9.33333Z"
          fill={fill}
        />
      </svg>
    </span>
  );
};

export default HashSVG;
